import { render, staticRenderFns } from "./WorkflowNodeWrapper.vue?vue&type=template&id=de53c344&"
import script from "./WorkflowNodeWrapper.vue?vue&type=script&lang=ts&"
export * from "./WorkflowNodeWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports